import { Toaster, ToasterProps } from 'react-hot-toast';
import { ErrorToast } from './Error';
import { InfoToast } from './Info';
import { SuccessToast } from './Success';
import { WarningToast } from './Warning';

function ToasterCustomized(props: ToasterProps) {
  return <Toaster containerClassName="[&:svg]:min-w-fit" {...props} />;
}

export const Toast = {
  error: ErrorToast,
  info: InfoToast,
  success: SuccessToast,
  Toaster: ToasterCustomized,
  warning: WarningToast,
};
